/**
 * Configuración modular de monedas soportadas
 * Para añadir una nueva moneda, solo agrega una entrada a este objeto.
 */

export interface CurrencyConfig {
  code: string;      // Código ISO (usd, eur, cop, etc)
  symbol: string;    // Símbolo visual
  name: string;      // Nombre descriptivo
  locale: string;    // Configuración regional para formateo de números
}

export const SUPPORTED_CURRENCIES: Record<string, CurrencyConfig> = {
  usd: {
    code: 'usd',
    symbol: '$',
    name: 'US Dollar',
    locale: 'en-US',
  },
  eur: {
    code: 'eur',
    symbol: '€',
    name: 'Euro',
    locale: 'de-DE',
  },
  cop: {
    code: 'cop',
    symbol: '$',
    name: 'Peso Colombiano',
    locale: 'es-CO',
  },
  // Ejemplo de escalabilidad:
  // mxn: {
  //   code: 'mxn',
  //   symbol: '$',
  //   name: 'Peso Mexicano',
  //   locale: 'es-MX',
  // },
};

export type CurrencyCode = keyof typeof SUPPORTED_CURRENCIES;

export const DEFAULT_CURRENCY: CurrencyCode = 'usd';
